import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import FormikFormErrorHandler from './FormikFormErrorHandler';
import { useField } from 'formik';

interface IProps {
  children: React.ReactNode;
  className: string;
  'data-testid'?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  validcharacter?: Array<string>;
  invalidcharacter?: Array<string>;
  maxLength: number;
  isallcharactervalid?: boolean;
}

const FormikFormPasswordField = (props: IProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const [field, meta, helpers] = useField(props);
  const errorClass = `${meta.error && meta.touched ? 'error' : ''}`;
  const { validcharacter, invalidcharacter, isallcharactervalid } = props;
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  let subStrArr = [
    '?',
    '>',
    '<',
    "'",
    '"',
    ':',
    ';',
    ',',
    '+',
    '-',
    '(',
    ')',
    '*',
    '&',
    '^',
    '%',
    '$',
    '#',
    '{',
    '[',
    ']',
    '}',
    '|',
    '/',
    '=',
    '_',
    '~',
    '\\',
    '`',
  ];

  if (validcharacter)
    subStrArr = subStrArr.filter((el) => !validcharacter.includes(el));
  if (invalidcharacter) invalidcharacter.forEach((el) => subStrArr.push(el));

  if (isallcharactervalid) subStrArr = [];

  return (
    <>
      <input
        {...field}
        {...props}
        placeholder={_placeholder}
        className={props.className + ' ' + errorClass}
        disabled={props.disabled}
        type={showPassword ? 'text' : 'password'}
        readOnly={props.readOnly}
        maxLength={props.maxLength}
        onChange={(event) => {
          if (event.target.value.length > props.maxLength)
            event.target.value = event.target.value.slice(0, props.maxLength);
          if (
            !props.spaceAllowed &&
            (event.target.value === '' ||
              !subStrArr.some((subStr: any) =>
                event.target.value.includes(subStr)
              ))
          ) {
            event.target.value = event.target.value.replace(/ +(?= )/g, '');
            helpers.setValue(event.target.value);
          } else if (
            (props.spaceAllowed === undefined || props.spaceAllowed) &&
            (event.target.value === '' ||
              !subStrArr.some((subStr: any) =>
                event.target.value.includes(subStr)
              ))
          ) {
            helpers.setValue(event.target.value);
          }
        }}
      />
      <span
        className="material-symbols-outlined hide-password fs-2"
        onClick={handleClickShowPassword}
      >
        {showPassword ? (
          <svg
            type="button"
            onClick={() => {
              handleClickShowPassword();
            }}
            viewBox="0 0 24 24"
            width="20"
            height="20"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="showHidePass css-i6dzq1 modalBox"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle
              cx="12"
              cy="12"
              r="3"
            ></circle>
          </svg>
        ) : (
          <svg
            type="button"
            onClick={() => {
              handleClickShowPassword();
            }}
            viewBox="0 0 24 24"
            width="20"
            height="20"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="showHidePass css-i6dzq1 modalBox"
          >
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
            <line
              x1="1"
              y1="1"
              x2="23"
              y2="23"
            ></line>
          </svg>
        )}
      </span>
      <FormikFormErrorHandler
        intl={props.intl}
        meta={meta}
      />
    </>
  );
};

export default injectIntl(FormikFormPasswordField);
